import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mainApi } from "../../api/axios";

/**
 * Get Recent Orders for dashboard
 */
export const getRecentOrders = createAsyncThunk(
  "dashboard/getRecentOrders",
  async (
    { storeId, startDate, endDate, offset, limit },
    { rejectWithValue },
  ) => {
    try {
      const res = await mainApi.get(
        `/v1/pos/orders?store_id=${storeId}&start_date=${startDate}&end_date=${endDate}&offset=${offset}&limit=${limit}`,
      );
      return res.data?.orders || [];
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

// Slice
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    recentOrders: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // Get Recent Orders
      .addCase(getRecentOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRecentOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.recentOrders = action.payload;
      })
      .addCase(getRecentOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {} = dashboardSlice.actions;
export default dashboardSlice.reducer;
